// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import "core-js/stable"
import "../components"
const Rails = require("@rails/ujs")

Rails.start()

global.Rails = Rails

import { run as runChangePassword } from "controllers/change_password"
import { run as runMfaCodeResendButton } from "controllers/mfa_code_resend_button"
import { run as runCodeInput } from "controllers/mfa_code_input"
import { run as runTogglePasswordVisibility } from "controllers/toggle_password_visibility"
import { run as runRequireCheckbox } from "controllers/require_checkbox"
import { run as runRequireInputs } from "controllers/require_inputs"
import { run as runAgreement } from "controllers/agreement"

// helper shelves

function toggleHelperShelfById(event) {
  const nodeId = event.currentTarget.dataset.helperShelfId
  const node = document.getElementById(nodeId)
  if (!node) {
    return
  }
  const nextHelperShelf = node.dataset.helperShelf === "closed" ? "open" : "closed"
  node.dataset.helperShelf = nextHelperShelf
  if (node.dataset.helperShelf === "closed") {
    node.style.height = "0px"
    node.style.visibility = "hidden"
  } else {
    node.style.height = node.scrollHeight + "px"
    node.style.visibility = "visible"
  }

  const controller = document.querySelector(`[data-helper-shelf-id="${nodeId}"]`)
  if (controller) {
    controller.setAttribute("aria-expanded", nextHelperShelf === "open")
  }
}

function setupHelperShelves() {
  const elements = document.querySelectorAll("[data-helper-shelf-id]")
  elements.forEach((element) => {
    element.addEventListener("click", toggleHelperShelfById)
  })
}

window.addEventListener("DOMContentLoaded", () => {
  runChangePassword()
  runMfaCodeResendButton()
  runCodeInput()
  runTogglePasswordVisibility()
  runRequireCheckbox()
  runRequireInputs()
  setupHelperShelves()
  runAgreement()
})
